import React, { Component } from 'react';
import { bool, string } from 'prop-types';
import { Panel, Table } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import CheckoutStepCalculator from '../../services/checkout-step-calculator';
import PaymentSelectionService from '../../services/payment-selection-service';
import spreeStore from '../../store';
import translations from '../../../translations/app-translations.json';
import APP_ROUTES from '../../constants/app-routes';
import actions from '../../actions';

class OrderSummary extends Component {
    subscriptionRef = null;

    constructor(props) {
        super(props);
        this.state = {
            paymentOption: null,
        };
    }

    componentDidMount() {
        this.subscriptionRef = PaymentSelectionService.selectedPaymentMethod$.subscribe((paymentOption) => {
            this.setState({
                paymentOption,
            });
        });
    }

    componentWillUnmount() {
        this.subscriptionRef.unsubscribe();
    }

    onNext() {
        // add here any generic logic for payment methods
        this.state.paymentOption.ref.current.onNext();
    }

    getSubmitButtonLabel() {
        const { locale } = this.props;
        return `${translations[locale]['pay-with']}${this.state.paymentOption ? ` ${this.state.paymentOption.name}` : ''}`;
    }

    getOrderPropertiesMapper() {
        let thisOrder = this.props.order;
        const ItemOrderNumber = <FormattedMessage id="order-number" defaultMessage="Orden no." />;
        const ItemTotalRep = <FormattedMessage id="itemTotal" defaultMessage="Item Total" />;
        const adjustmentTotalRep = <FormattedMessage id="adjustmentTotal" defaultMessage="Adjustment Total" />;
        const shippingTotalRep = <FormattedMessage id="shippingTotal" defaultMessage="Shipping Total" />;
        const orderTotalRep = <FormattedMessage id="orderTotal" defaultMessage="Order Total" />;

        if (this.props.placedOrder && this.props.placedOrder.id) {
            thisOrder = this.props.placedOrder;
        }

        const orderPropertiesMapper = [];
        const isValidStep = this.props.isCheckoutSummary ? CheckoutStepCalculator.isValidStep(thisOrder.checkout_steps, this.props.currentCheckoutStep) : true;

        // debugger
        if (isValidStep || !this.props.isCheckoutSummary) {
            orderPropertiesMapper.push([ItemOrderNumber, thisOrder.number]);

            orderPropertiesMapper.push([ItemTotalRep, thisOrder.display_item_total]);

            // eslint-disable-next-line radix
            if (parseFloat(thisOrder.adjustment_total) > 0) {
                orderPropertiesMapper.push([adjustmentTotalRep, thisOrder.display_adjustment_total]);
            }
        }

        if (this.props.isCheckoutSummary) {
            if (thisOrder.checkout_steps.indexOf(this.props.currentCheckoutStep) >= 1) {
                orderPropertiesMapper.push([shippingTotalRep, thisOrder.display_ship_total]);
            }
        } else {
            orderPropertiesMapper.push([shippingTotalRep, thisOrder.display_ship_total]);
        }

        orderPropertiesMapper.push([orderTotalRep, thisOrder.display_total]);

        return orderPropertiesMapper;
    }

    mapPropertiesToTable() {
        const orderPropertiesMapper = this.getOrderPropertiesMapper();
        return orderPropertiesMapper.map((property, idx) => (
            <tr key={`order-prop-${idx}`}>
                <td>
                    <label>{property[0]}</label>
                </td>
                <td>{property[1]}</td>
            </tr>
        ));
    }

    backToPrevStep() {
        window.scrollTo(0, 0);
        spreeStore.dispatch(actions.goToPrevStep(this.props.order, this.props.locale, 'payment'));
    }

    render() {
        const { currentCheckoutStep } = spreeStore.getState();
        return (
            <div className={`checkout-order-details ${this.props.className}`}>
                <Panel>
                    <Panel.Heading>
                        <Panel.Title componentClass="h3">
                            <b>
                                <FormattedMessage id="summaryHeader" defaultMessage="Order Summary" />
                            </b>
                        </Panel.Title>
                    </Panel.Heading>
                    <Table>
                        <tbody>{this.mapPropertiesToTable()}</tbody>
                    </Table>
                    {currentCheckoutStep === 'payment' && this.state.paymentOption && (
                        <div>
                            <hr />
                            <button
                                type="submit"
                                className="button--outlined"
                                disabled={!this.state.paymentOption.ref.current || !this.state.paymentOption.ref.current.shouldNextBeEnabled()}
                                style={{ width: '100%', height: 'auto', fontSize: 16 }}
                                onClick={() => {
                                    this.onNext();
                                }}
                            >
                                {this.getSubmitButtonLabel()}
                            </button>
                            <button
                                onClick={() => { this.backToPrevStep(); }}
                                type="button"
                                className="btn btn-link"
                                style={{ width: '100%' }}
                            >
                                <FormattedMessage id="back" defaultMessage="Back" />
                            </button>
                        </div>
                    )}
                </Panel>
            </div>
        );
    }
}

export default injectIntl(OrderSummary);

OrderSummary.defaultProps = {
    isCheckoutSummary: true,
    className: '',
};

OrderSummary.propTypes = {
    isCheckoutSummary: bool,
    className: string,
};



/** WEBPACK FOOTER **
 ** ./src/components/order/summary.jsx
 **/